export default __webpack_public_path__ + "fdf166bea97b26737adfc2706c3e0f8a.jpg";